module.exports = __webpack_public_path__ + "static/media/rundkolben_antwort2.23eb2c12.png";